module.exports = __webpack_public_path__ + "img/raw-fm.a3b86820.png";